import * as pdfjsLib from "pdfjs-dist";

const convertFiletoDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.normalize());
    reader.onerror = error => reject(error);
});

const convertPdfPageToImage = (pdf, pageNumber) => new Promise(resolve => {
    pdf.getPage(pageNumber).then(page => {
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const renderContext = { canvasContext: ctx, viewport };

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render(renderContext).promise.then(() => {
            resolve({ id: pageNumber, image: canvas.toDataURL() });
        });
    });
})

export const convertPdfFilesToImages = (files) => new Promise(resolve => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;
    const worker = new pdfjsLib.PDFWorker();

    const promises = Array.from(Array(files.length), (_, index) => new Promise(resolve2 => {
        const file = files[index];
        convertFiletoDataUrl(file).then(dataUrl =>
            pdfjsLib.getDocument({ url: dataUrl, worker }).promise.then(pdf => {
                const promises2 = Array.from(Array(pdf.numPages), (__, index2) => new Promise(resolve3 => {
                    const pageNumber = index2 + 1;
                    convertPdfPageToImage(pdf, pageNumber).then(resolve3);
                }));
                Promise.all(promises2).then(resolve2);
            })
        );
    }));

    Promise.all(promises).then(f => resolve(f.flat()));
});

export const InvoiceCuttingStatus = {
    IN_PROGRESS: "IN_PROGRESS",
    PENDING_VALIDATION: "PENDING_VALIDATION",
    VALIDATED: "VALIDATED",
    DONE: "DONE",
    FAILED: "FAILED",
};